module.exports = __webpack_public_path__ + "static/img/ncepu.2c80b32b.png";